import { Box, Button, FormLabel, Link, Stack, Typography } from "@mui/material";
import { PaymentIntentPresentError } from "../PaymentIntentPresentError/PaymentIntentPresentError";
import { InfoDisclaimerBox } from "@covertree/ui/content";
import { CoverageEffectiveDate } from "@covertree/ui";
import { Control } from "react-hook-form";
import { ContinueQuoteForm } from "../validation";

interface Props {
  canContinueQuote: boolean;
  disclaimerMessage: string;
  emailAddress: string;
  control: Control<ContinueQuoteForm>;
  policyLocator: string;
  isValid: boolean;
  closeContinueQuoteModal: () => void;
  handleSubmit: () => void;
}

export function ContinueYourQuoteModalContent({
  canContinueQuote,
  closeContinueQuoteModal,
  control,
  disclaimerMessage,
  emailAddress,
  handleSubmit,
  isValid,
  policyLocator,
}: Props) {
  if (!canContinueQuote) {
    return <PaymentIntentPresentError onClose={closeContinueQuoteModal} />;
  }

  return (
    <>
      <InfoDisclaimerBox
        dataTestId="continue-your-quote-modal"
        fontSize={16}
        mb={2}
        spacing={1.5}>
        {disclaimerMessage} If you require a different adjustment, please
        contact IA team at{" "}
        <Link color="secondary" href={`mailto:${emailAddress}`}>
          {emailAddress}
        </Link>
      </InfoDisclaimerBox>
      <Typography variant="h6">Policy ID: {policyLocator}</Typography>
      <Stack direction="column" mt={2} spacing={2}>
        <FormLabel
          sx={{
            color: "text.primary",
          }}>
          Coverage effective date
        </FormLabel>
        <CoverageEffectiveDate
          control={control}
          name="effectiveDate"
          displayInCard={false}
          disabled={false}
          withHeader={false}
          hideSubtitle
        />
      </Stack>
      <Box mt={4} columnGap={3} display="flex">
        <Button disabled={!isValid} type="submit" onClick={handleSubmit}>
          Continue
        </Button>
        <Button onClick={closeContinueQuoteModal} variant="outlined">
          Cancel
        </Button>
      </Box>
    </>
  );
}
